import { useEffect, useRef, useState } from "react"
import DashboardMap from "./DashboardMap";
import DashboardPendingCard from "./DashboardPendingCard";
import IncidentCountCard from "./IncidentCountCard";
import QuickAccessCard from "./QuickAccessCard";
import DashboardTemplate from "./DashboardTemplate";
import AcknowledgeCountCard from "./AcknowledgeCountCard";
import DashboardActiveWarningCard from "./DashboardActiveWarningCard";

const Dashboard = () => {
    return (
        <div className="dashboard-main">
            <div className="dashboard-wrapper">
                <DashboardMap gridArea="map"/>
                <div className="count-wrapper" style={{gridArea: 'dash-card-1'}}>
                    <DashboardPendingCard gridArea=""/>
                    <DashboardActiveWarningCard gridArea="" />
                    <IncidentCountCard gridArea=""/>
                    <AcknowledgeCountCard gridArea="" />
                </div>
                
                {/* <QuickAccessCard gridArea="dash-card-3" title="Quick Access"/> */}
                <DashboardTemplate gridArea="dash-card-2" title="Early warning templates"/>
            </div>
        </div>
        
    )
}

export default Dashboard